import { faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDetectClickOutside } from "react-detect-click-outside";

import React, { useEffect, useState } from "react";

const SortButton = ({ handlesort, orderby, closeDropdown }: any) => {
  const [open, setOpen] = useState(false);
  const [sortby, setSortby] = useState("pair_name");
  const ref = useDetectClickOutside({ onTriggered: () => setOpen(false) });

  const handleopen = () => {
    setOpen(!open);
  };
  useEffect(() => {
    handlesort("ascn");
    orderby(sortby);
  }, [sortby]);
  return (
    <>
      <div className="poolSort assetsort" onClick={handleopen} ref={ref}>
        <div>
          <FontAwesomeIcon icon={faSort} />
        </div>

        <div>Sort by</div>
        {open ? (
          <div className="sortby-menu">
            <div
              onClick={() => {
                setSortby("pair_name");
                setOpen(!open);
              }}
              className={`sortby-input ${
                sortby === "pair_name" ? "sortby-input__active" : ""
              }`}
            >
              Pair name
            </div>
            <div
              onClick={() => {
                setSortby("Liquidity");
                setOpen(!open);
              }}
              className={`sortby-input ${
                sortby === "Liquidity" ? "sortby-input__active" : ""
              }`}
            >
              Liquidity
            </div>
            {/* <div
        onClick={() => {setSortby('Volume'); setOpen(!open)}}
        className={`sortby-input ${
          sortby === 'Volume' ? "sortby-input__active" : ""
        }`}
      >
        Volume
      </div> */}
            <div
              onClick={() => {
                setSortby("APR");
                setOpen(!open);
              }}
              className={`sortby-input ${
                sortby === "APR" ? "sortby-input__active" : ""
              }`}
            >
              APR
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default SortButton;
